import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Dropdown from "../../shared/Dropdown";
import CategoriesWrapper from "../styles/Categories.style";

function Categories(props) {
  return (
    <CategoriesWrapper className="categories">
      <Dropdown
        buttonClass="filter--toggle"
        autoClose
        text={
          <>
            Categories <ArrowDropDownIcon />
          </>
        }
      >
        <div className="categories-container">
          {props.search.categoryList !== undefined &&
            props.search.categoryList.map((item, index) => (
              <Link key={index} to={`/licensing/search?category=${item}`}>
                <Button>{item}</Button>
              </Link>
            ))}
        </div>
      </Dropdown>
    </CategoriesWrapper>
  );
}

export default Categories;
